import { Directive, forwardRef } from '@angular/core';
import { NG_VALIDATORS, Validator, AbstractControl, ValidationErrors } from '@angular/forms';

import { ValidationRules } from 'rev-shared/util/ValidationRules';

@Directive({
	selector: '[vbShort]',
	providers: [{
		provide: NG_VALIDATORS,
		useExisting: forwardRef(() => VbShortDirective),
		multi: true
	}],
	standalone: false
})
export class VbShortDirective implements Validator {
	public validate(control: AbstractControl): ValidationErrors {
		return ValidationRules.checkShortText(control.value) ? null : { vbShort: true };
	}
}
